import { api_LoadCancelledSalesOrderForCustomerMobileApp } from "../../connection/api/api-profile";
import { PT_VIEWINVOICE } from "../../routes/stack/paths/pt-orders";
import { KEY_GENERATOR } from "../../functions/funtion";
import { dto_common } from "../../classes/dto-common";
import { F_Fammily } from "../../util/config-fonts";
import { Colors } from "../../util/colors";
import React from "react";

export default class CancelledOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      CancelledSalesInvoice: [],
      isDataEmpty: false,
    };
  }

  async LoadCancelledOrders() {
    let data = await api_LoadCancelledSalesOrderForCustomerMobileApp();
    let objData = JSON.parse(data);
    if (objData !== "[[]]") {
      this.setState({ CancelledSalesInvoice: [] });
      let objobjData = JSON.parse(objData);
      this.setState({
        CancelledSalesInvoice: objobjData[0],
        isDataEmpty: false,
      });
    } else {
      this.setState({ isDataEmpty: true });
    }
  }

  async componentDidMount() {
    await this.LoadCancelledOrders();
  }

  render() {
    return (
      <div
        className="addListHeaderr fadateInUp animed"
        style={{ textAlign: "center", marginTop: "20px" }}
      >
        {this.state.isDataEmpty ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "60px",
            }}
          >
            <img
              src={require("../orders/components/orders-view/NoDataFound.jpg")}
              width={"60%"}
              alt=""
            />

            <label
              style={{
                fontWeight: "bold",
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              No Orders Found
            </label>
            <label
              style={{
                textAlign: "center",
                display: "block",
              }}
            >
              Try ordering something
            </label>
          </div>
        ) : (
          <div style={{ paddingBottom: "50px" }}>
            {this.state.CancelledSalesInvoice.map((rs) => (
              <div
                className="pgOrderCard fadeInUp animated"
                key={KEY_GENERATOR()}
                style={{
                  border: " 1px solid #ccc",
                  height: 200,
                  borderRadius: "8px",
                  marginBottom: 10,
                }}
              >
                <div style={{ width: "100%", height: 120, display: "flex" }}>
                  <div
                    style={{
                      width: "75%",
                      marginLeft: "15px",
                      marginTop: "13px",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "left",
                        fontWeight: 600,
                        marginTop: 0,
                      }}
                    >
                      {rs.Merchant.length > 20
                        ? `${rs.Merchant.substring(0, 20)}...`
                        : rs.Merchant}{" "}
                    </p>

                    <p style={{ fontSize: 12, textAlign: "left" }}>
                      Order No : {rs.GUNO}
                    </p>

                    <p style={{ fontSize: 12, textAlign: "left" }}>
                      {rs.Delivery}
                    </p>

                    <p
                      style={{
                        textAlign: "left",
                        fontFamily: F_Fammily.Regular,
                      }}
                    >
                      Total : {parseFloat(rs.Total).toFixed(2)}
                    </p>
                  </div>

                  <div
                    style={{
                      width: "45%",
                      marginLeft: "5px",
                      marginRight: "5%",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "left",
                        fontSize: "12px",
                        fontWeight: "bold",
                        marginBottom: "3px",
                        color: "red",
                      }}
                    >
                      Status : Cancelled
                    </div>
                    <img
                      alt={rs.ImageURL}
                      src={rs.ImageURL}
                      onError={(e) => {
                        e.currentTarget.src = dto_common.DefaultImageUrl;
                      }}
                      style={{
                        border: " 1px solid #ccc",
                        height: 100,
                        width: "80%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>

                <div>
                  <hr />
                  <div>
                    <button
                      style={{
                        fontFamily: F_Fammily.Medium,
                        width: "100%",
                        height: 40,
                        borderRadius: "5px",
                        fontSize: "medium",
                        backgroundColor: Colors.DarkGreyScale,
                        color: "white",
                        border: "1px solid Colors.DarkGreyScale",
                      }}
                      onClick={() => {
                        this.props.navigate(
                          PT_VIEWINVOICE.replace(
                            ":frmPage",
                            "ordercompleted"
                          ).replace(":orderID", rs.POSID)
                        );
                      }}
                    >
                      View Order
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}
